module.exports = __webpack_public_path__ + "img/icon63.71376cbc.png";